/* eslint-disable */
import React, { useState, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";

import { getData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { assetImages } from "constants";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import OrderDetailsPopup from "./Popup/OrderDetailsPopup";
import OrderListFilterPopup from "./Popup/OrderListFilterPopup";

const OrdersSection = () => {
  const params = useParams();
  const { t } = useTranslation();
  const token = localStorage.getItem("token");

  const [isLoading, setIsLoading] = useState(false);
  const [orderList, setOrderList] = useState([]);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedOrderIds, setSelectedOrderIds] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  //function for get all orders
  const getAllOrders = async () => {
    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_INVOICE_BY_TYPES +
        `?token=${token}&typeslug=order&clientids=${params.id}&ispaid=true&status=1`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl += `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("requestUrl in order list", requestUrl);

      const response = await getData(requestUrl);

      console.log("response", response);

      setIsLoading(false);

      console.log(response);

      if (response.status) {
        setOrderList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  // function for get all my orders
  // useEffect(() => {
  //   getAllOrders();
  // }, []);

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllOrders();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllOrders();
      setReloadData(false);
    }
  }, [reloadData]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: "Actions",
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasOrderDetails"
            aria-controls="offcanvasOrderDetails"
            onClick={() => {
              setSelectedOrderId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false,
        enableColumnDragging: false,
        enableSorting: false,
      },
      {
        header: "Order Id",
        accessorKey: "orderid",
      },
      {
        header: "Order Date",
        accessorKey: "invoicedate",
      },
      {
        header: "Client Name",
        accessorKey: "clientfullname",
        Cell: ({ row }) => (
          <div className="owner border-bottom-0 d-flex align-items-center gap-1">
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.clientimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.clientimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.clientfullname}</span>
            </p>
          </div>
        ),
      },
      { accessorKey: "amount", header: "Amount" },
      {
        accessorKey: "itemnames",
        header: "Items",
        size: 300, // Adjust the width as needed
        Cell: ({ row }) => (
          <ul className="list-style-none p-0 m-0">
            {row.original.invoiceitems.map((item, index) => (
              <li key={index}>
                {item.description} (Qty: {item.unit}, Price: ${item.totalprice})
              </li>
            ))}
          </ul>
        ),
      },
    ],
    []
  );

  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  // function for get selected order ids
  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedOrderIds(selectedIdsArray);
    } else {
      setSelectedOrderIds([]);
    }
  }, [rowSelection]);

  return (
    <div className="p-4 bg-white h-100 rounded-10 shadow-sm">
      <div className="filter-container mb-4">
        <div className="row align-items-center mb-4">
          <div className="col-lg-4">
            <h3 className="mb-0">Orders</h3>
          </div>
          <div className="col-lg-8 d-flex align-items-center justify-content-end gap-1 gap-sm-2">
            <Link to="#" className="btn btn-gray" onClick={resetFilterData}>
              <span className="d-block material-symbols-outlined">refresh</span>
            </Link>
            <Link
              to="#"
              className="btn btn-gray"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasOrderFilter"
              aria-controls="offcanvasOrderFilter"
            >
              <span className="d-block material-symbols-outlined">tune</span>
            </Link>
          </div>
        </div>
      </div>

      {isLoading ? (
        <LoadingSkeleton />
      ) : (
        <div className="table-wrapper">
          <MaterialReactTable
            columns={columns}
            data={orderList}
            enableGrouping
            enableRowSelection
            getRowId={(row) => row._id}
            onRowSelectionChange={setRowSelection}
            state={{ rowSelection, columnOrder }}
            initialState={{ rowSelection, columnOrder }}
            defaultColumn={{
              minSize: 20,
              maxSize: 300,
              size: 50,
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: "60vh",
              },
            }}
            enableStickyHeader
          />
        </div>
      )}

      <OrderDetailsPopup
        orderId={selectedOrderId}
        setOrderId={setSelectedOrderId}
      />

      <OrderListFilterPopup
        moduleSlug="orderlist"
        setJsonFilterQuery={setJsonFilterQuery}
        isFilterReset={isFilterReset}
        setIsFilterReset={setIsFilterReset}
        reloadList={resetFilterData}
        columns={columns}
      />
    </div>
  );
};

export default OrdersSection;
